import React, { Fragment } from 'react';
import { has, values } from 'lodash/fp';
import { Icon, Tooltip, Whisper } from 'rsuite';
import PropTypes from 'prop-types';
import { parseInt } from '../../helpers/utils';
import HealthLevels from '../../constants/common/HealthLevels';
import HealthLevelLabels from '../../constants/common/HealthLevelLabels';

const HealthLevelValues = values(HealthLevels);
const TrafficlightColorByValue = {
  [HealthLevels.GO]: '#7ED321',
  [HealthLevels.SLOW]: '#F8E71C',
  [HealthLevels.WHOA]: '#D0021B'
};

const StoplightTooltip = ({ value, ...props }) => (
  <Tooltip {...props}>
    Traffic-Light Nutrition Indicator: {HealthLevelLabels[value]}
  </Tooltip>
);

StoplightTooltip.propTypes = {
  value: PropTypes.oneOf(HealthLevelValues).isRequired
};

const StoplightIndicator = ({ value, style, ...props }) => (
  <Fragment>
    {has(value, TrafficlightColorByValue) ? (
      <Whisper
        placement="top"
        trigger="hover"
        speaker={<StoplightTooltip value={parseInt(value)} />}
      >
        <Icon
          {...props}
          icon="circle"
          style={{
            color: TrafficlightColorByValue[value],
            ...style
          }}
        />
      </Whisper>
    ) : (
      'N/A'
    )}
  </Fragment>
);

StoplightIndicator.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  style: PropTypes.shape({})
};

StoplightIndicator.defaultProps = {
  style: {}
};

export default StoplightIndicator;
